import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/reactions/like.png'
import _imports_1 from '@/assets/images/reactions/love.png'
import _imports_2 from '@/assets/images/reactions/haha.png'
import _imports_3 from '@/assets/images/reactions/celebrate.png'
import _imports_4 from '@/assets/images/reactions/gratitude.png'
import _imports_5 from '@/assets/images/reactions/wow.png'
import _imports_6 from '@/assets/images/reactions/sad.png'


const _hoisted_1 = { class: "reaction-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "reaction-container"
}
const _hoisted_3 = {
  key: 0,
  class: "reaction reaction--like"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "reaction reaction--love"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_7 = {
  key: 2,
  class: "reaction reaction--haha"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_9 = {
  key: 3,
  class: "reaction reaction--celebrate"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_11 = {
  key: 4,
  class: "reaction reaction--gratitude"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1)
const _hoisted_13 = {
  key: 5,
  class: "reaction reaction--wow"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1)
const _hoisted_15 = {
  key: 6,
  class: "reaction reaction--sad"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1)
const _hoisted_17 = { class: "reaction-count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VTooltip = _resolveComponent("VTooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.reactionCount())
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.includesReaction(_ctx.ReactionId.LIKE))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_VTooltip, { distance: 12 }, {
                  popper: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reactionAuthors(_ctx.ReactionId.LIKE), (author) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: author.userId,
                        class: "reaction-owner"
                      }, _toDisplayString(author.userProfile.firstName) + " " + _toDisplayString(author.userProfile.lastName), 1))
                    }), 128))
                  ]),
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.includesReaction(_ctx.ReactionId.LOVE))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_VTooltip, { distance: 12 }, {
                  popper: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reactionAuthors(_ctx.ReactionId.LOVE), (author) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: author.userId,
                        class: "reaction-owner"
                      }, _toDisplayString(author.userProfile.firstName) + " " + _toDisplayString(author.userProfile.lastName), 1))
                    }), 128))
                  ]),
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.includesReaction(_ctx.ReactionId.HAHA))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_VTooltip, { distance: 12 }, {
                  popper: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reactionAuthors(_ctx.ReactionId.HAHA), (author) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: author.userId,
                        class: "reaction-owner"
                      }, _toDisplayString(author.userProfile.firstName) + " " + _toDisplayString(author.userProfile.lastName), 1))
                    }), 128))
                  ]),
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.includesReaction(_ctx.ReactionId.CELEBRATE))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_VTooltip, { distance: 12 }, {
                  popper: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reactionAuthors(_ctx.ReactionId.CELEBRATE), (author) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: author.userId,
                        class: "reaction-owner"
                      }, _toDisplayString(author.userProfile.firstName) + " " + _toDisplayString(author.userProfile.lastName), 1))
                    }), 128))
                  ]),
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.includesReaction(_ctx.ReactionId.GRATITUDE))
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_VTooltip, { distance: 12 }, {
                  popper: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reactionAuthors(_ctx.ReactionId.GRATITUDE), (author) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: author.userId,
                        class: "reaction-owner"
                      }, _toDisplayString(author.userProfile.firstName) + " " + _toDisplayString(author.userProfile.lastName), 1))
                    }), 128))
                  ]),
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.includesReaction(_ctx.ReactionId.WOW))
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_VTooltip, { distance: 12 }, {
                  popper: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reactionAuthors(_ctx.ReactionId.WOW), (author) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: author.userId,
                        class: "reaction-owner"
                      }, _toDisplayString(author.userProfile.firstName) + " " + _toDisplayString(author.userProfile.lastName), 1))
                    }), 128))
                  ]),
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.includesReaction(_ctx.ReactionId.SAD))
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_VTooltip, { distance: 12 }, {
                  popper: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reactionAuthors(_ctx.ReactionId.SAD), (author) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: author.userId,
                        class: "reaction-owner"
                      }, _toDisplayString(author.userProfile.firstName) + " " + _toDisplayString(author.userProfile.lastName), 1))
                    }), 128))
                  ]),
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_VTooltip, { distance: 12 }, {
              popper: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reactionAuthors(), (author) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: author.userId,
                    class: "reaction-owner"
                  }, _toDisplayString(author.userProfile.firstName) + " " + _toDisplayString(author.userProfile.lastName), 1))
                }), 128))
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.reactionCount()), 1)
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}